import React from 'react';
import EstadosForm from '../../../components/ui/Cliente/EstadosComponents/FormEstados';

const EstadosUI = () => {
  return (
    <div className=" bg-gray-100">
      <EstadosForm />
    </div>
  );
};

export default EstadosUI;